import { Navigate } from 'react-router-dom'

/** redirect เก่า → แท็บประวัติเกมส์ / ซองแดง */
export default function RedEnvelopeHistoryPage() {
  return <Navigate to="/history/games/red-envelope" replace />
}
